import styled from 'styled-components'
import { COLORS } from '../../constants'

export const Container = styled.div<{ $active: boolean }>`
  display: flex;
  padding: 0 1.5rem 0 1.5rem;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  min-height: 8rem;
  width: 90%;
  background-color: ${({ $active }) =>
    $active ? COLORS.background : COLORS.backgroundDark};
  margin: 1rem 0 0.5rem 0;
  border-radius: 5px;
  border: none;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: background-color 0.2s ease;
`

export const Div = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  &:nth-child(1) {
    width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;

    p {
      font-size: 1rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
      position: relative;
      padding-left: 1.2rem;

      &::before {
        content: '•';
        position: absolute;
        left: 0;
        font-size: 1rem;
        line-height: 1.2rem;
      }

      &:hover {
        white-space: normal;
        overflow: visible;
        max-width: 100%;
      }
    }
    p:nth-of-type(1) {
      margin-bottom: 0.7rem;
    }
    p:nth-of-type(2):nth-last-of-type(2) {
      margin-bottom: 0.7rem;
    }
    span {
      font-weight: bold;
    }
  }

  &:nth-child(2) {
    width: 15%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > p {
      font-size: 1rem;
      display: flex;
      align-items: center;
      width: 100%;
    }

    > p::before {
      content: attr(data-label);
      margin-right: 8px;
      font-weight: bold;
    }
  }

  &:nth-child(3) {
    width: 15%;
    flex-direction: row;
    > label {
      font-weight: bold;
    }
    .fui-Input {
      width: 4rem;
    }
  }

  &:nth-child(4) {
    width: 15%;
    > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      > p {
        font-size: 1rem;
        display: flex;
        align-items: center;
        width: 100%;
      }

      > p::before {
        content: attr(data-label);
        margin-right: 8px;
        font-weight: bold;
      }
    }
  }

  &:nth-child(5) {
    width: 15%;
  }
`
